import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vant/lib/index.css';
// import '@vant/touch-emulator';


import('./assets/css/reset.css');
import('./assets/css/common.css');

import { Button,Popup,Tabbar, TabbarItem,Search,Area,
  Field,Icon,Col, Row,Tab, Tabs,List,Tag ,Uploader ,
  Swipe, Form,SwipeItem, Divider, Cell, CellGroup, Collapse, 
  CollapseItem,Notify, PullRefresh,Toast,Calendar,RadioGroup, 
  Radio,Stepper,Checkbox,Picker,CheckboxGroup   } from 'vant';

import Msg from './plugins/msg';
import Tool from './plugins/tool';

Vue.config.productionTip = false;

//注册插件
Vue.use(Msg);
Vue.use(Tool);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Search);
Vue.use(Area);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(PullRefresh);
Vue.use(Notify);
Vue.use(Toast);
Vue.use(Calendar);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Stepper);
Vue.use(Checkbox);
Vue.use(Picker);
Vue.use(CheckboxGroup);


store.commit('user/UPDATEUSERINFO');

new Vue({
    render: h => h(App),
    router,
    store,
    beforeCreate() {
      Vue.prototype.$bus = this;
    }
}).$mount('#app');
